import styled from 'styled-components';

const ContactFormStyle = styled.section`
	--titleMarg: var(--sp5x);
	--inputMarg: var(--sp7x);
	--colorSwitcher: var(--sp8x);

	.stepsContainer {
		position: relative;
		overflow: hidden;

		.step {
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			z-index: -1;

			&.activeStep {
				position: static;
				z-index: 1;
			}
		}

		.formTitle {
			font-size: var(--formSize);
			margin-bottom: var(--titleMarg);
			word-break: break-word;
			opacity: 0;
			line-height: var(--lineHeightFormTitle) !important;
		}

		.inputWrapClass {
			opacity: 0;
			position: relative;
			z-index: 1;
			padding-bottom: var(--inputMarg);

			.inputClass {
				position: relative;

				input {
					width: 100%;
					font-size: var(--formSize);
					font-weight: var(--ffMedium);
					font-family: var(--fontFamily2);
					border: 0px;
					outline: none;
					padding-right: calc(var(--smileSize) + 15px);
					color: var(--color2);
					line-height: var(--lineHeightForm);

					&::placeholder {
						color: var(--color2);
						font-size: var(--formSize);
						font-weight: var(--ffMedium);
						font-family: var(--fontFamily2);
						line-height: var(--lineHeightForm);
					}
				}

				svg {
					stroke: var(--color2);
				}
			}
		}
	}

	.thankYouWrap {
		.thankYouAnime {
			position: relative;
			margin-bottom: var(--sp5x);
			padding-top: 50%;
			opacity: 0;

			svg {
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				bottom: 0;
				width: 100%;
				height: 100%;
			}
		}
		.OtherContact {
			.OtherContactSubTitle {
				margin-bottom: var(--sp2x);
			}
		}
	}

	.OtherFunctionality {
		text-align: center;

		.colorSwitcher {
			height: var(--colorSwitcher);
		}

		.topSection {
			margin-bottom: var(--sp3x);
		}
	}

	.backLink {
		position: absolute;
		text-decoration: underline;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) {
		.OtherFunctionality {
			.topSection {
				position: relative;
				display: flex;
				justify-content: flex-end;
			}

			margin-bottom: var(--sp5x);
		}

		.backLink {
			top: 50%;
			left: 0;
			transform: translateY(-50%);
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
		--colorSwitcher: var(--sp9x);
	}

	@media only screen and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
		.thankYouWrap {
			display: flex;
			flex-wrap: wrap;
			align-items: center;

			.thankYouAnime {
				margin-bottom: 0;

				svg {
					max-width: 56%;
				}
			}
		}
	}

	@media only screen and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
		--colorSwitcher: var(--sp12x);

		.OtherFunctionality {
			position: absolute;
			top: 24vh;
			z-index: 11;
		}

		.backLink {
			transform: rotate(-90deg);
			top: auto;
			left: 2%;
		}

		.thankYouWrap {
			.thankYouAnime {
				padding-top: 24%;
			}
		}
	}

	@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXL}) {
		--colorSwitcher: var(--sp15x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
		.OtherFunctionality {
			margin-bottom: var(--sp8x);

			.topSection {
				margin-bottom: 0;
			}
		}

		.thankYouWrap {
			.thankYouAnime {
				flex: 0 0 42%;
				padding-top: 28%;
			}

			.OtherContact {
				flex: 0 0 58%;
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
		--titleMarg: var(--sp5x);
		--inputMarg: var(--sp8x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
		.OtherFunctionality {
			right: var(--sp4x);
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
		.thankYouWrap {
			.thankYouAnime {
				flex: 0 0 46%;
			}

			.OtherContact {
				flex: 0 0 54%;
			}
		}
	}

	@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
		.OtherFunctionality {
			right: var(--sp5x);
		}

		.thankYouWrap {
			.thankYouAnime {
				flex: 0 0 46%;
			}

			.OtherContact {
				flex: 0 0 54%;

				.OtherContactSubTitle {
					margin-bottom: var(--sp3x);
				}
			}
		}
	}

	@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeL}) {
		.thankYouWrap {
			.thankYouAnime {
				flex: 0 0 57%;
			}

			.OtherContact {
				flex: 0 0 43%;

				.OtherContactSubTitle {
					margin-bottom: var(--sp3x);
				}
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
		--titleMarg: var(--sp8x);
		--inputMarg: var(--sp10x);

		.thankYouWrap {
			.thankYouAnime {
				flex: 0 0 46%;
			}

			.OtherContact {
				flex: 0 0 54%;
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeM}) {
		--titleMarg: var(--sp10x);
		--inputMarg: var(--sp13x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeL}) {
		--titleMarg: var(--sp10x);
		--inputMarg: var(--sp13x);
	}

	@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXL}) {
		--titleMarg: var(--sp17x);
		--inputMarg: var(--sp15x);

		.OtherFunctionality {
			right: var(--sp15x);
		}

		.backLink {
			left: var(--sp10x);
		}
	}
`;

export default ContactFormStyle;
